/**
 * useStudentThemeScope — bascule le design system sur le thème élève le temps de l'espace élève.
 *
 * Le pendant de `useParentThemeScope`, sur la portée commune des espaces (`createSpaceThemeScope`) :
 * le thème élève — Automatique par défaut, le réglage de l'appareil (`studentAppearancePreference`) —
 * à l'entrée, la main rendue au thème d'avant à la sortie (l'élève passe à l'espace parent, ou se
 * déconnecte). Le compte des écrans qui le tiennent (la coquille, le live et sa note) : la portée.
 */
import { useColorScheme } from "react-native"

import { createSpaceThemeScope } from "./spaceThemeScope"
import { useStudentAppearancePreference } from "./studentAppearancePreference"
import { studentThemeFor } from "./studentThemeFor"

export const useStudentThemeScope = createSpaceThemeScope(() => {
    const preference = useStudentAppearancePreference()
    // Comme chez le parent : tant qu'une apparence est forcée sur iOS, `useColorScheme()` rend la
    // valeur forcée — la règle ne s'en sert qu'en Automatique, où la main est rendue au système.
    return { theme: studentThemeFor(useColorScheme(), preference), preference }
})
